import { render, staticRenderFns } from "./model-manage.vue?vue&type=template&id=c5d7278c&scoped=true"
import script from "./model-manage.vue?vue&type=script&lang=js"
export * from "./model-manage.vue?vue&type=script&lang=js"
import style0 from "./model-manage.vue?vue&type=style&index=0&id=c5d7278c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d7278c",
  null
  
)

export default component.exports